import {
  Box,
  Container,
  Stack,
  useMediaQuery,
  SxProps,
  Theme
} from '@mui/material';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

type LayoutProps = {
  title: string;
  children: JSX.Element | JSX.Element[];
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  px?: { xs?: number; sm?: number; md?: number; lg?: number; xl?: number };
  sx?: SxProps<Theme>;
};

const PersistentDrawerRight = dynamic(() => import('../DrawerMenu'));
const Header = dynamic(() => import('../Header'));
const Footer = dynamic(() => import('../Footer'));
const Reward = dynamic(() => import('../Reward'));

const Layout = ({
  title,
  children,
  maxWidth = 'lg',
  px = { xs: 5, lg: 0 },
  sx = {} // Set default empty object for sx
}: LayoutProps) => {
  const isMobile: boolean = useMediaQuery((theme: any) =>
    theme.breakpoints.down('md')
  );

  const router = useRouter();

  const hideRewardOnPages = ['/contact', '/about'];
  const shouldHideReward = hideRewardOnPages.includes(router.pathname);

  return (
    <Box position="relative" sx={{ ...sx }}>
      <Head>
        <title>{title}</title>
      </Head>
      {isMobile && <PersistentDrawerRight />}
      <Header />
      {!shouldHideReward && <Reward />}
      <Box sx={{ overflowX: 'hidden' }}>
        <Container maxWidth={maxWidth}>
          <Stack gap={{ lg: 10, xs: 6 }} px={px}>
            {children}
          </Stack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default Layout;
